import React from 'react';

export const useClickedOutside = (
    ref: React.RefObject<any>,
    outSideClickCallback: () => void,
    ignoredClassNames?: Array<string | undefined>
) => {
    React.useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (ref.current && !ref.current.contains(event.target)) {
                const target = event.target;
                const ignoredMatchingStyleClasses =
                    ignoredClassNames?.filter(item => target.className.includes(item)) || [];

                if (!ignoredMatchingStyleClasses.length) {
                    outSideClickCallback();
                }
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref]);
};
